import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-acdc-converter')
export class ObiAcdcConverter extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z" fill="currentColor"/>
<path d="M2 2H11V4H2V2Z" fill="currentColor"/>
<path d="M2 6H11V8H2V6Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5285 17.7066L21.8829 18.4703C21.8559 18.5023 21.8232 18.5429 21.7853 18.5901C21.5859 18.8381 21.2413 19.2669 20.8033 19.5706C20.1984 19.9899 19.4241 20.1989 18.4458 19.9981C17.5182 19.8077 16.8836 19.3425 16.4102 18.9954C16.3985 18.9868 16.3869 18.9783 16.3754 18.9699C15.8843 18.6102 15.5591 18.3848 15.0848 18.2874C14.7906 18.227 14.6085 18.2438 14.437 18.3048C14.2378 18.3756 13.9674 18.5373 13.5545 18.914L12.8157 19.5879L11.4678 18.1104L12.2065 17.4364C12.7071 16.9798 13.2078 16.6192 13.7671 16.4204C14.354 16.2117 14.9179 16.2115 15.4869 16.3283C16.4145 16.5187 17.0491 16.9839 17.5225 17.331C17.5342 17.3396 17.5458 17.3481 17.5573 17.3565C18.0484 17.7162 18.3736 17.9416 18.848 18.039C19.2945 18.1307 19.5112 18.0327 19.6638 17.9269C19.8428 17.8028 19.9636 17.6552 20.1514 17.4256C20.2113 17.3524 20.278 17.2708 20.3556 17.1791L21.0012 16.4154L22.5285 17.7066Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z" style="fill: var(--element-active-color)"/>
<path d="M2 2H11V4H2V2Z" style="fill: var(--element-active-color)"/>
<path d="M2 6H11V8H2V6Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5285 17.7066L21.8829 18.4703C21.8559 18.5023 21.8232 18.5429 21.7853 18.5901C21.5859 18.8381 21.2413 19.2669 20.8033 19.5706C20.1984 19.9899 19.4241 20.1989 18.4458 19.9981C17.5182 19.8077 16.8836 19.3425 16.4102 18.9954C16.3985 18.9868 16.3869 18.9783 16.3754 18.9699C15.8843 18.6102 15.5591 18.3848 15.0848 18.2874C14.7906 18.227 14.6085 18.2438 14.437 18.3048C14.2378 18.3756 13.9674 18.5373 13.5545 18.914L12.8157 19.5879L11.4678 18.1104L12.2065 17.4364C12.7071 16.9798 13.2078 16.6192 13.7671 16.4204C14.354 16.2117 14.9179 16.2115 15.4869 16.3283C16.4145 16.5187 17.0491 16.9839 17.5225 17.331C17.5342 17.3396 17.5458 17.3481 17.5573 17.3565C18.0484 17.7162 18.3736 17.9416 18.848 18.039C19.2945 18.1307 19.5112 18.0327 19.6638 17.9269C19.8428 17.8028 19.9636 17.6552 20.1514 17.4256C20.2113 17.3524 20.278 17.2708 20.3556 17.1791L21.0012 16.4154L22.5285 17.7066Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-acdc-converter': ObiAcdcConverter;
  }
}
